






















import { Component, Vue } from "vue-property-decorator";
import SidebarHeader from "@/app/views/nubii/components/sidebar/components/sidebarHeader.component.vue";
import SidebarFooter from "@/app/views/nubii/components/sidebar/components/sidebarFooter.component.vue";
import SidebarUserlist from "@/app/views/nubii/components/sidebar/components/sidebarUserList.component.vue";
import SidebarMenuComponent from "@/app/views/nubii/components/sidebar/components/sidebarMenu.component.vue";
import feather from "feather-icons";
@Component({
  name: "nubii-sidebar-component",
  components: {
    SidebarMenuComponent,
    SidebarUserlist,
    SidebarFooter,
    SidebarHeader,
  },
})
export default class SidebarComponent extends Vue {
  feather = feather;
  city = false;
  created(): void {
    this.city = localStorage.getItem("city") == "ON" ? false : true;
  }
  sidebarFull(): boolean {
    return this.$store.getters["SidebarStore/getSidebarFull"];
  }
  get activeMenu() {
    return this.$store.getters["SidebarStore/getActiveMenu"];
  }
  get openCall(): boolean {
    const openCall = this.$store.getters["SidebarStore/getOpenCall"];
    return openCall;
  }
  setActiveMenu(e) {
    document.getElementsByClassName("vs-tooltip")[0].remove();
    const element = document.getElementsByClassName("open-menu-container")[0];
    if (element) element["style"].left = "-23rem";
    setTimeout(() => {
      this.$store.dispatch("SidebarStore/setActiveMenuAction", e);
    }, 200);
  }
}
